import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Selection() {
    const {data : {about: {selection : {data,name}}}} = useGetSettingQuery()

    return ( 
        <>
        <div className="feature-bg">
            <div className="feature-bg-after" style={{backgroundImage: `url(${data.img_image})`}}></div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="featured-text">
                            {name && <h2 className="pb-3">{name.split(" ")[0]} <span className="orange-text">{name.split(" ").slice(1).join(" ")}</span></h2>}
                            <div className="row">
                                {data.lso_features && data.lso_features.map((row,index) => 
                                <div className="col-lg-6 col-md-6 mb-4 mb-md-5" key={index}>
                                    <div className="list-box d-flex">
                                        <div className="list-icon">
                                            <i className={row.ico_icon}></i>
                                        </div>
                                        <div className="content">
                                            <h3>{row.txt_title}</h3>
                                            <p>{row.txe_body}</p>
                                        </div>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Selection;